import { render, staticRenderFns } from "./farm-attachments.vue?vue&type=template&id=fa866554&scoped=true"
import script from "./farm-attachments.vue?vue&type=script&lang=js"
export * from "./farm-attachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa866554",
  null
  
)

export default component.exports